import { createContext, useContext } from 'react'

type GreenCardInsuranceValues = {
  isEditable: boolean
  isCalculatingLoading: boolean
  handleCalculate: (onSuccess: () => void) => Promise<void>
  handleRecalculate: () => void
}

const GreenCardInsuranceContext = createContext<GreenCardInsuranceValues>({
  isEditable: false,
  isCalculatingLoading: false,
  handleCalculate: () => Promise.resolve(),
  handleRecalculate: () => null
})

export const GreenCardInsuranceProvider = ({
  children,
  ...values
}: React.PropsWithChildren<GreenCardInsuranceValues>) => {
  return (
    <GreenCardInsuranceContext.Provider value={values}>
      {children}
    </GreenCardInsuranceContext.Provider>
  )
}

export const useGreenCardInsuranceValues = () =>
  useContext(GreenCardInsuranceContext)
